import UsuariosView from './UsuariosView.vue'
import CreacionUsuariosView from './CreacionUsuariosView.vue'
import EdicionUsuariosView from './EdicionUsuariosView.vue'

export default [
  {
    path: '',
    component: UsuariosView
  },
  {
    path: 'nuevo',
    component: CreacionUsuariosView
  },
  {
    path: 'edicion/:id',
    component: EdicionUsuariosView
  }
];